import React from "react";

// Maps an order/payment status to a colour. First match wins.
const MAP = [
  { m: ["out for delivery", "out_for_delivery"], c: "bg-indigo-100 text-indigo-700 border-indigo-200", pulse: true },
  { m: ["delivered", "paid in full"], c: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  { m: ["transit", "dispatched", "shipped"], c: "bg-blue-100 text-blue-700 border-blue-200", pulse: true },
  { m: ["tailor", "production", "packed", "progress", "cutting", "stitch"], c: "bg-amber-100 text-amber-700 border-amber-200", pulse: true },
  { m: ["advance", "confirmed"], c: "bg-teal-100 text-teal-700 border-teal-200" },
  { m: ["paid"], c: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  { m: ["cancel", "failed", "refund"], c: "bg-red-100 text-red-700 border-red-200" },
  { m: ["placed", "pending", "await"], c: "bg-gray-100 text-gray-600 border-gray-200" },
];

export default function StatusBadge({ status, className = "" }) {
  const s = String(status || "").toLowerCase();
  const hit = MAP.find((x) => x.m.some((k) => s.includes(k)));
  const cls = hit ? hit.c : "bg-gray-100 text-gray-600 border-gray-200";
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] font-medium capitalize whitespace-nowrap ${cls} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full bg-current ${hit?.pulse ? "animate-pulse" : "opacity-70"}`} />
      {String(status || "").replace(/_/g, " ") || "—"}
    </span>
  );
}
